import {Vue} from "ui.vue";

import {VuexBasketRestClient} from "./lib/rest.js";

const Events = {
	CHANGED: "Citrus.Component.Basket:update",
}

/**
 * @package citrus.vuex.basket
 */
const basket = {
	namespaced: true,
	state: {
		products: {},
		loading: [],
		isViewStock: false,
		orderMakeMinutes: 0,
		orderStock: {
			enable: false,
			min_date: "",
			min_time: ""
		},
		excludedDates: []
	},
	actions: {
		remove(store, productId) {
			if (false === store.getters.check(productId)) {
				return false;
			}

			productId = typeof productId === "number" ? productId : parseInt(productId);

			let restClient = new VuexBasketRestClient(productId);
			store.commit("startLoadProduct", productId);
			return restClient.remove().then((result) => {
				store.commit("endLoadProduct", productId);
				store.commit("removeProduct", result.product);
				Vue.event.$emit(Events.CHANGED);
			});
		},
		add(store, params) {
			if (typeof params != "object" || !params.hasOwnProperty("id") || !params.hasOwnProperty("quantity")) {
				params = {
					id: parseInt(params),
					quantity: 1
				}
			}

			let productId = typeof params.id === "number" ? params.id : parseInt(params.id);
			let quantity = typeof params.quantity === "number" ? params.quantity : parseInt(params.quantity);

			let restClient = new VuexBasketRestClient(productId, quantity);
			store.commit("startLoadProduct", productId);
			return restClient.add().then((result) => {
				store.commit("endLoadProduct", productId);
				store.commit("addProduct", {
					id: result.product,
					quantity: result.quantity,
				});
				Vue.event.$emit(Events.CHANGED);
			});
		},
		load(store, products) {
			let restClient = new VuexBasketRestClient();

			store.commit("loadProducts", products);
			return restClient.load().then((result) => {
				store.commit("loadProducts", result.products);
			});
		},
		change(store, params) {
			if (typeof params != "object" || !params.hasOwnProperty("id") || !params.hasOwnProperty("quantity")) {
				params = {
					id: parseInt(params),
					quantity: 1
				}
			}

			let productId = typeof params.id === "number" ? params.id : parseInt(params.id);
			let quantity = typeof params.quantity === "number" ? params.quantity : parseInt(params.quantity);

			let restClient = new VuexBasketRestClient(productId, quantity);
			store.commit("startLoadProduct", productId);
			return restClient.update().then((result) => {
				store.commit("endLoadProduct", productId);
				store.commit("updateProduct", {
					id: result.product,
					quantity: result.quantity,
				});
				Vue.event.$emit(Events.CHANGED);
			});
		},
		changeItems(store, items) {
			console.log("changeItems");
			let restClient = new VuexBasketRestClient(0, 0);
			console.log("VuexBasketRestClient");
			return restClient.updateItems(items).then((result) => {
				console.log("updateItems");
				for (let i in items) {
					if (items[i].quantity == 0) {
						store.commit("removeProduct", items[i].id);
					} else {
						store.commit("updateProduct", items[i]);
					}
				}
				console.log("$emit");
				Vue.event.$emit(Events.CHANGED);
			});
			console.log("end");
		},
		toggleViewStock(store, isViewStock) {
			store.commit("toggleViewStock", isViewStock);
		},
		setOrderMakeMinutes(store, minutes) {
			store.commit("setOrderMakeMinutes", minutes);
		},
		setOrderStock(store, stock) {
			store.commit("setOrderStock", stock);
		},
		setExcludedDates(store, stock) {
			store.commit("setExcludedDates", stock);
		}
	},
	mutations: {
		loadProducts(state, products) {
			state.products = products;
		},
		removeProduct(state, id) {
			Vue.delete(state.products, id);
		},
		updateProduct(state, params) {
			Vue.set(state.products, params.id, params.quantity);
		},
		addProduct(state, params) {
			if (state.products.hasOwnProperty(params.id)) {
				Vue.set(state.products, params.id, state.products[params.id] + params.quantity);
			} else {
				Vue.set(state.products, params.id, params.quantity);
			}
		},
		startLoadProduct(state, id) {
			if (!state.loading.includes(id)) {
				state.loading.push(id);
			}
		},
		endLoadProduct(state, id) {
			state.loading = state.loading.filter(elem => elem != id);
		},
		toggleViewStock(state, isViewStock) {
			state.isViewStock = isViewStock;
		},
		setOrderMakeMinutes(state, minutes) {
			state.orderMakeMinutes = minutes;
		},
		setOrderStock(state, stock) {
			state.orderStock = stock;
		},
		setExcludedDates(state, stock) {
			state.excludedDates = stock;
		}
	},
	getters: {
		loading: state => id => {
			return state.loading.includes(id)
		},
		count: state => Object.keys(state.products).length,
		check: state => id => {
			id = typeof id === "number" ? id : parseInt(id);
			return state.products.hasOwnProperty(id);
		},
		quantity: state => id => {
			id = typeof id === "number" ? id : parseInt(id);
			return state.products.hasOwnProperty(id) ? state.products[id] : 0;
		},
		isViewStock: state => {
			return state.isViewStock;
		},
		orderMakeMinutes: state => {
			return state.orderMakeMinutes;
		},
		orderStock: state => {
			return state.orderStock;
		},
		excludedDates: state => {
			return state.excludedDates;
		}
	}
};

export {basket};

